module.exports = {"TXTWCL_Responsible_gaming":{"id":"TXTWCL_Responsible_gaming","defaultMessage":"Υπεύθυνο παιχνίδι.","track":"Responsible gaming"}}